var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHandPointing = function SvgIconHandPointing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.093 1.342A2.875 2.875 0 0 1 13 3.375v3.261a2.875 2.875 0 0 1 3.355 1.285A2.875 2.875 0 0 1 20.5 10.5v3.75a8.5 8.5 0 0 1-8.5 8.5c-2.302 0-4.068-.645-5.644-2.224-1.495-1.499-2.782-3.81-4.3-7.006a2.877 2.877 0 0 1 5.008-2.835l.186.324V3.375c0-.763.303-1.494.843-2.033M16.75 10.5h-2V9.375a.875.875 0 1 0-1.75 0 1 1 0 1 1-2 0v-6a.875.875 0 1 0-1.75 0v11.372a1 1 0 0 1-1.866.5l-2.053-3.563a.877.877 0 0 0-1.52.876l.037.07c1.531 3.228 2.696 5.252 3.925 6.484C8.925 20.27 10.159 20.75 12 20.75a6.5 6.5 0 0 0 6.5-6.5V10.5a.875.875 0 1 0-1.75 0",
    clipRule: "evenodd"
  })));
};
export default SvgIconHandPointing;